import React from 'react'

import { sanitizeAndProcessHtml } from '@/_lib/dom-purify.utils'

export interface ListItem {
	content: string
	items?: ListItem[]
}

export interface ListData {
	items: (ListItem | string)[]
	style: 'ordered' | 'unordered'
}

export interface BEditorJsListProps {
	data: ListData
}

export const BEditorJsList: React.FC<BEditorJsListProps> = ({ data }) => {
	const { items, style } = data

	const renderNestedList = (
		listItems: (ListItem | string)[],
		listStyle: 'ordered' | 'unordered'
	) => {
		const ListComponent = listStyle === 'ordered' ? 'ol' : 'ul'

		const sharedClasses = 'mb-8 text-[#4A337A] list-inside'
		const listClasses =
			listStyle === 'ordered' ? `${sharedClasses} list-decimal` : `${sharedClasses} list-disc`

		return (
			<ListComponent className={listClasses}>
				{listItems.map((item, index) => {
					if (typeof item === 'string') {
						return (
							<li key={index} className='mb-2 text-[#4A337A]'>
								<span
									suppressHydrationWarning
									dangerouslySetInnerHTML={{
										__html: sanitizeAndProcessHtml(item)
									}}
								/>
							</li>
						)
					}

					return (
						<li key={index} className='mb-2 text-[#4A337A]'>
							<span
								suppressHydrationWarning
								dangerouslySetInnerHTML={{
									__html: sanitizeAndProcessHtml(item.content)
								}}
							/>
							{item.items && item.items.length > 0 && (
								<div className='pl-4'>
									{renderNestedList(item.items, listStyle)}
								</div>
							)}
						</li>
					)
				})}
			</ListComponent>
		)
	}

	return <div className='editorjs-renderer_block'>{renderNestedList(items, style)}</div>
}

export default BEditorJsList
